import {
  API_CALL,
  UPLOAD_GEOGROUPS,
  UPLOAD_GEOGROUPS_RESULT,
  UPLOAD_GEOGROUPS_FAILED,
} from './types';

export const uploadGeogroups = (csvString) => ({
  type: API_CALL,
  onRequest: UPLOAD_GEOGROUPS,
  onResponse: UPLOAD_GEOGROUPS_RESULT,
  onError: UPLOAD_GEOGROUPS_FAILED,
  payload: {
    method: 'POST',
    url: `/geogroups/upload`,
    data: { csvString }
  }
});
